import { takeLatest, call, put } from 'redux-saga/effects';
import Api from '../../Api';
import {
  ARCHIVE_PROJECT_FAIL,
  ARCHIVE_PROJECT_REQUEST,
  DELETE_PROJECT_FAIL,
  DELETE_PROJECT_REQUEST,
  GET_PROJECTS_FAIL,
  GET_PROJECTS_REQUEST,
  GET_PROJECTS_SUCCESS, RECOVER_PROJECT_FAIL, RECOVER_PROJECT_REQUEST, SAVE_PROJECT_FAIL,
  SAVE_PROJECT_REQUEST, SAVE_PROJECT_SUCCESS,
} from '../actions/projects';

export default function* watcher() {
  yield takeLatest(GET_PROJECTS_REQUEST, getProjects);
  yield takeLatest(SAVE_PROJECT_REQUEST, saveProject);
  yield takeLatest(DELETE_PROJECT_REQUEST, deleteProject);
  yield takeLatest(ARCHIVE_PROJECT_REQUEST, archiveProject);
  yield takeLatest(RECOVER_PROJECT_REQUEST, recoverProject);
}

function* getProjects(action) {
  try {
    const { data } = yield call(Api.getProjects, action.payload);

    yield put({
      type: GET_PROJECTS_SUCCESS,
      payload: data,
    });
  } catch (e) {
    console.log(e, 'while getting projects');
    console.log(e?.response?.data);
    yield put({
      type: GET_PROJECTS_FAIL,
      message: e?.message,
      payload: e?.response?.data,
    });
  }
}

function* saveProject(action) {
  try {
    let data;
    if (action.payload.save) {
      const res = yield call(Api.addProject, action.payload.data);
      data = res.data;
    } else {
      const res = yield call(Api.editProject, action.payload.data);
      data = res.data;
    }

    yield put({
      type: SAVE_PROJECT_SUCCESS,
      payload: data,
    });
  } catch (e) {
    console.log(e, 'while saving project');
    console.log(e?.response?.data);
    yield put({
      type: SAVE_PROJECT_FAIL,
      message: e?.message,
      payload: e?.response?.data,
    });
  }
}

function* deleteProject(action) {
  try {
    const { id, requestData } = action.payload;
    yield call(Api.deleteProject, id);
    yield put({
      type: GET_PROJECTS_REQUEST,
      payload: requestData,
    });
  } catch (e) {
    console.log(e, 'while deleting project');
    console.log(e?.response?.data);
    yield put({
      type: DELETE_PROJECT_FAIL,
      message: e?.message,
      payload: e?.response?.data,
    });
  }
}

function* archiveProject(action) {
  try {
    const { id, requestData } = action.payload;
    yield call(Api.archiveProject, id);
    yield put({
      type: GET_PROJECTS_REQUEST,
      payload: requestData,
    });
  } catch (e) {
    console.log(e, 'while archiving project');
    console.log(e?.response?.data);
    yield put({
      type: ARCHIVE_PROJECT_FAIL,
      message: e?.message,
      payload: e?.response?.data,
    });
  }
}

function* recoverProject(action) {
  try {
    const { id, requestData } = action.payload;
    yield call(Api.recoverProject, id);
    yield put({
      type: GET_PROJECTS_REQUEST,
      payload: requestData,
    });
  } catch (e) {
    console.log(e, 'while recovering project');
    console.log(e?.response?.data);
    yield put({
      type: RECOVER_PROJECT_FAIL,
      message: e?.message,
      payload: e?.response?.data,
    });
  }
}
